const getPlotLineConfig = ({ id, lineColor, dashStyle, text, textColor, value }) => ({
  width: 2,
  id,
  color: lineColor,
  dashStyle,
  label: {
    useHTML: true,
    align: 'right',
    text,
    style: {
      fontWeight: 'bold',
      color: textColor,
    },
    x: 0,
  },
  zIndex: 5,
  value,
});

// сдвигает лейблы плотлайнов на yAxis[0] при их наложении друг на друга
const fixPlotLineLabels = (yAxis) => {
  const plotlines = [...yAxis[0].plotLinesAndBands]
    .sort((a, b) => a.id - b.id)
    .filter(({ label }) => label !== undefined);
  if (plotlines.length > 0) {
    plotlines.reduce(
      (prevPlotLine, plotLine) => {
        let newPlotLine;
        if (prevPlotLine.label.align === 'right') {
          newPlotLine = {
            ...plotLine.options,
            label: {
              ...plotLine.options.label,
              align: 'left',
            },
          };
        } else {
          newPlotLine = {
            ...plotLine.options,
            label: {
              ...plotLine.options.label,
              align: 'right',
            },
          };
        }

        yAxis[0].removePlotLine(plotLine.id);
        yAxis[0].addPlotLine(newPlotLine);
        return newPlotLine;
      },
      { label: { align: 'left' } }
    );
  }
};

const updateYaxisPlotLines = (plotLines = [], { yAxis }) => {
  if ((yAxis || []).length > 0) {
    yAxis[0].plotLinesAndBands
      .map(({ id }) => id)
      .forEach((id) => {
        yAxis[0].removePlotLine(id);
      });
    plotLines.forEach((plotLine) => yAxis[0].addPlotLine(getPlotLineConfig(plotLine)));
    fixPlotLineLabels(yAxis);
  }
};

export default updateYaxisPlotLines;
